import React, { useState, useContext } from "react";
// import icons
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
// import headless ui components
import { Menu } from "@headlessui/react";
// import context
import { HouseContext } from "../../context/HouseContext";

const PropertyDropdown = () => {
  const { property, setProperty, properties } = useContext(HouseContext);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Menu as="div" className="dropdown relative">
      <Menu.Button
        onClick={() => setIsOpen(!isOpen)}
        className="dropdown-btn w-full text-left bg-white rounded-none"
      >
        <div className="flex justify-center items-center w-full">
          <div className="text-[16px] font-medium leading-tight">
            {property}
          </div>
        </div>
        {isOpen ? (
          <RiArrowUpSLine className="dropdown-icon-secondary text-primary" />
        ) : (
          <RiArrowDownSLine className="dropdown-icon-secondary text-primary" />
        )}
      </Menu.Button>

      <Menu.Items className="dropdown-menu sm:text-black text-black bg-white">
        {properties.map((property, index) => {
          return (
            <Menu.Item
              as="li"
              onClick={() => setProperty(property)}
              key={index}
              className="cursor-pointer hover:text-primary transition"
            >
              {property}
            </Menu.Item>
          );
        })}
      </Menu.Items>
    </Menu>
  );
};

export default PropertyDropdown;
